var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 42,
    viewBox: "0 0 51 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6352 29.9675H5.36518M40.5002 2.5C41.8263 2.5 43.098 3.02678 44.0357 3.96447C44.9734 4.90215 45.5002 6.17392 45.5002 7.5V28.815C45.4998 29.5936 45.6813 30.3615 46.0302 31.0575L48.7002 36.375C48.8929 36.7575 48.9842 37.183 48.9652 37.6109C48.9462 38.0388 48.8176 38.4546 48.5917 38.8185C48.3659 39.1824 48.0503 39.4821 47.6753 39.689C47.3003 39.8959 46.8785 40.003 46.4502 40H4.55017C4.1219 40.003 3.70004 39.8959 3.32504 39.689C2.95004 39.4821 2.63448 39.1824 2.40861 38.8185C2.18275 38.4546 2.05416 38.0388 2.03517 37.6109C2.01619 37.183 2.10744 36.7575 2.30017 36.375L4.97018 31.0575C5.31903 30.3615 5.50051 29.5936 5.50017 28.815V7.5C5.50017 6.17392 6.02696 4.90215 6.96464 3.96447C7.90232 3.02678 9.17409 2.5 10.5002 2.5H40.5002Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.8496eaa60f0d192b62d9641bf8ba000e.svg";
export { ForwardRef as ReactComponent };